module.exports = __webpack_public_path__ + "assets/img/7_814_big.c02cbc45.jpg";